import React, {useEffect, useRef, useState} from 'react';
import {Spinner, Button, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import Main, {Time, Subtitle, Videoplayer} from './elements/VideoPlayer';
import {useStore} from '../../store';
import Play from '../../assets/icons/play-solid.png';
import Replay from '../../assets/icons/replay.png';
import {amplitude} from '../../utils/Amplitude';

// eslint-disable-next-line no-unused-vars
const VideoPlayer = observer(({videoId, thumbnail}) => {
  const ref = useRef();
  const [playerLoaded, setPlayerLoaded] = useState(false);
  const [playerLoadInitiated, setPlayerLoadInitiated] = useState(false);
  const {videoStore, accountStore} = useStore();
  const {
    setVideoPlayer,
    videoTimeExceeded,
    setVideoTimeExceeded,
    videoPause,
    setVideoPause,
    setRewatch,
    videoPlayer,
    noFreeMin,
  } = videoStore;

  const {account} = accountStore;

  const registerClicked = () => {
    const eventProperties = {
      location: 'player',
    };
    amplitude.getInstance().logEvent('register-clicked-v3', eventProperties);
  };

  useEffect(() => {
    if (!playerLoadInitiated && videoId && !noFreeMin) {
      setPlayerLoadInitiated(true);
      setVideoPlayer(ref, videoId)
        .then(() => {
          setPlayerLoaded(true);
        })
        .catch(() => {
          setPlayerLoaded(false);
        });
    }
    if (videoTimeExceeded) {
      setPlayerLoadInitiated(false);
    }
  }, [ref, playerLoaded, videoId, setVideoPlayer, playerLoadInitiated, videoTimeExceeded, noFreeMin]);

  return (
    <Videoplayer>
      {!playerLoaded && !noFreeMin && (
        <Main>
          <div className="spinner-wrapper w-100 h-100 d-flex align-items-center justify-content-center">
            <Spinner animation="grow" role="status" variant="secondary">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        </Main>
      )}
      {noFreeMin ? (
        <Main>
          <img className="position-absolute w-100 h-100" src={thumbnail} ref={ref} alt="Video thumbnail" />
          <div className="lock-wrapper">
            <Link to="/login" className="lock-link">
              <i className="fas fa-lock-alt lock-icon" />
            </Link>
          </div>
        </Main>
      ) : (
        [
          videoTimeExceeded ? (
            <Main>
              <img className="position-absolute w-100 h-100" src={thumbnail} ref={ref} alt="Video thumbnail" />
              <div className="lock-wrapper">
                <Time>Finish this video</Time>
                <Subtitle>Register today to watch the full video.</Subtitle>
                <Row className="py-4">
                  <Button
                    className="watch-btn"
                    onClick={() => {
                      setVideoTimeExceeded(false);
                      setRewatch(true);
                    }}
                  >
                    Rewatch video
                    <img src={Replay} className="pl-3 pr-1 watch-icon" alt="replay" />
                  </Button>
                  <Link to={account?.id ? '/profile/plan-update' : '/register'} className="register paused">
                    <Button onClick={registerClicked} className="mx-3 register-btn">
                      Subscribe Now
                    </Button>
                  </Link>
                </Row>
              </div>
            </Main>
          ) : (
            <div className="video-screen">
              <div ref={ref} />
              {videoPause ? (
                <Main className="pausedContainer">
                  <img className="position-absolute w-100 h-100" src={thumbnail} alt="Video thumbnail" />
                  <div className="lock-wrapper">
                    <Time>Keep Learning</Time>
                    <Subtitle>Register today to watch the full video.</Subtitle>
                    <Row className="py-4">
                      <Button
                        className="watch-btn"
                        onClick={() => {
                          setVideoPause(false);
                          videoPlayer?.play();
                        }}
                      >
                        Keep watching
                        <img src={Play} className="pl-3 pr-1 watch-icon" alt="play" />
                      </Button>
                      <Link to={account?.id ? '/profile/plan-update' : '/register'} className="register paused">
                        <Button onClick={registerClicked} className="mx-3 register-btn">
                          Subscribe Now
                        </Button>
                      </Link>
                    </Row>
                  </div>
                </Main>
              ) : null}
            </div>
          ),
        ]
      )}
    </Videoplayer>
  );
});
VideoPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
};

export default VideoPlayer;
